import axios from "axios";
import dayjs from "dayjs";
import jwt_decode from "jwt-decode";

const validateAccessToken = async () => {
  let currentAccessToken = localStorage.getItem("accessToken");

  // accessToken이 존하지 않는다면 로그인 페이지로 이동
  if (!currentAccessToken) {
    location.href = "/login";
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("accessToken");
    return "";
  }

  // accessToken의 유효기간이 종료되었다면 refreshToken을 통해 accessToken 갱신
  if (
    dayjs(
      (jwt_decode(currentAccessToken) as { exp: number }).exp * 1000
    ).isBefore(dayjs())
  ) {
    const { accessToken, refreshToken } = await refreshAccessToken();

    localStorage.setItem("accessToken", accessToken);
    localStorage.setItem("refreshToken", refreshToken);

    currentAccessToken = accessToken;
  }

  return currentAccessToken ?? "";
};

const validateRefreshToken = () => {
  const refreshToken = localStorage.getItem("refreshToken");

  // refreshToken이 없거나 유효기간이 종료되었다면 로그인 페이지로 이동
  if (
    !refreshToken ||
    dayjs((jwt_decode(refreshToken) as { exp: number }).exp * 1000).isBefore(
      dayjs()
    )
  ) {
    location.href = "/login";
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("accessToken");
  }

  return refreshToken ?? "";
};

const refreshAccessToken = async () => {
  try {
    const response = await axios
      .create({
        baseURL: import.meta.env.VITE_BASE_API_URL,
        headers: {
          contentType: "application/json",
          AuthorizationR: validateRefreshToken(),
        },
      })
      .get("/api/user/refresh-token");
    return response.data.data;
  } catch (err) {
    console.error(err);
    location.href = "/login";
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("accessToken");
  }
};

export { validateAccessToken, validateRefreshToken, refreshAccessToken };
